// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1KjmF","left":"InfoRow_left__2ZIEo"};